export default {"src":"/_next/static/media/buildings.617bc9e5.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};